
const routes = {
  WEB_HOMEPAGE: '/home',
  ABOUT: '/about',
  PRIVACY_POLICY: '/PrivacyPolicy',
  TERMS_AND_CONDITIONS: '/TermsAndConditions',
  REFUND_AND_CANCELLATION: '/RefundAndCancellation',
  ICICI_TERMS_AND_CONDITIONS: '/ICICITermsAndConditions',
  // LENDING_PARTNERS: "/partnersforlending",
  SUPPORTED_TREATMENTS: "/supportedtreatements",
  FINDOC_DECLARTION: "/partnersforlending/fldgdeclaration",
  HOPE_GUARD: '/hopeguard-affiliates',
  APP_DOWNLOAD: '/app/download',
  APP_CAREENA: '/app/careena',
  KYC_TPA_REDIRECT: '/kyc/tpa/:leadId',
  KYC_TPA_FACE_VERIFICATION: '/kyc/tpa/face-verification/:leadId',
  KYC_TPA_FACE_VERIFIED: '/kyc/tpa/face-verified/:leadId',
  KYC_TPA_ELIGIBILITY_CHECK: '/kyc/tpa/eligibility-check/:leadId',

  MEDIASSIST_KYC_CONSENT: '/ma/kyc-consent/:leadId',
  MEDIASSIST_DIGILOCKER_KYC_INTRO: '/ma/digilockerintro/:leadId',
  MEDIASSIST_AGREEMENT_CONSENT: '/ma/agreement-consent/:loanId',
  MEDIASSIST_DIGI_BANK_STATEMENT: '/ma/digibankstatement/:leadId',
  MEDIASSIST_AGREEGATOR: '/ma/agreegator/:leadId',
  MEDIASSIST_DIGITAP_REDIRECT_URL: '/tpa/digitapredirection/*',
  MEDIASSIST_DIGI_REPORT: '/ma/digireport/*',
  MEDIASSIST_DIGITAP_REPORT_FAILURE: '/ma/reporfailure',
  MEDIASSIST_DIGITAP_REPORT_FAILURE_NEW: '/ma/reporfailuretry',
  MEDIASSIST_BANK_NAME_NOTMATCHED: '/ma/banknamenotmatched',
  MEDIASSIST_BANK_API_NOT_WORKING: '/ma/bankserverdown',
  MEDIASSIST_BANK_DETAILS_FOR_NACH: '/ma/bankdetailsforNACH/*',
  MEDIASSIST_BANK_VERIFIED: '/ma/bankverified/*',
  MEDIASSIST_EMI_AUTO_PAY_SETUP: '/ma/emiautopaysetup/*',

  PATIENT_HOMEPAGE: '/patient/*',
  PONAWALA_HOMEPAGE: '/pw/*',
  DOCTOR_NOT_AVAILABLE: '/patient/DoctorNotAvailable',
  MOBILE_NUMBER_VERIFICATION: '/patient/MobileNumberVerification',
  ENTER_OTP: '/patient/EnterOTP',

  PHONE_NUMBER_VERIFIED: '/patient/PhoneNumberVerified',

  CREDIT_DETAILS: '/patient/CreditDetails',
  PRESCRIPTION_UPLOAD: '/patient/PrescriptionUpload',
  PERSONAL_DETAILS: '/patient/PersonalDetails',
  NOT_SERVICEABLE: '/patient/NotServiceable',
  ADDRESS_DETAILS: '/patient/AddressDetails',
  ADDRESS_NOT_SERVICEABLE: '/patient/AddressNotServiceable',
  EMPLOYMENT_DETAILS: '/patient/EmploymentDetails',
  LOAN_DETAILS: '/patient/LoanDetails',
  CREDIT_FAIR_OFFERS: '/patient/CreditFairOffers',

  WAITING_FOR_APPROVAL: '/patient/WaitingForApproval',
  CHECKING_STATUS: '/patient/ChechkingStatus',
  CF_APPROVED: '/patient/CfApproved',
  REJECTED_SCREEN: '/patient/RejectedScreen/:userId',
  REJECTED_BY_BS: '/patient/rejectionbybs/:userId',

  SEARCHING_OFFERS: '/patient/SearchingOffers',
  CONGRATS_PRE_APPROVED_ICICI: '/patient/congratsPreApprovedIcici',
  EMI_OPTIONS: '/patient/EmiOptions',
  PAN_VERIFICATION_ICICI: '/patient/PanVerificationIcici',
  CONGRATS_APPROVED_ICICI: '/patient/congratsApprovedIcici',
  FINAL_CONSENT: '/patient/FinalConsent',

  FIBE_MOBILE_NUMBER_VERIFICATION: '/patient/fibeMobileNumberVerification',
  PONAWALA_MOBILE_NUMBER_VERIFICATION: '/pw/mobile-verification',
  PONAWALA_ENTER_OTP: '/pw/enter-otp',
  PONAWALA_PHONE_NUMBER_VERIFIED: '/pw/number-verified',
  PONAWALA_TREATMENT_DETAILS: '/pw/treatment-details/:userId',
  PONAWALA_PERSONAL_DETAILS: '/pw/personal-details/:userId',
  PONAWALA_PROFESSIONAL_DETAILS: '/pw/professional-details/:userId',
  PONAWALA_KYC_VERIFICATION: '/pw/kyc-verification/:userId',
  PONAWALA_FACE_VERIFICATION: '/pw/face-verification/:userId',
  PONAWALA_FACE_VERIFIED: '/pw/face-verified/:loanId',
  PONAWALA_AADHAAR_VERIFICATION: '/pw/aadhaar-verification/:loanId',
  PONAWALA_AADHAAR_DIGILOCKER_STATUS: '/pw/aadhaar-digilocker-status/:loanId',
  PONAWALA_AADHAAR_VERIFIED: '/pw/aadhaar-verified/:loanId',
  PONAWALA_ADDRESS_DETAILS: '/pw/address-details/:loanId',
  PONAWALA_PATIENT_ADDRESS_DETAILS: '/pw/patient-address-details/:loanId',
  PONAWALA_PATIENT_KYC_VERIFICATION: '/pw/patient-kyc-verification/:loanId',
  PONAWALA_PATIENT_AADHAAR_VERIFICATION: '/pw/patient-aadhaar-verification/:loanId',
  PONAWALA_PATIENT_AADHAAR_DIGILOCKER_STATUS: '/pw/patient-aadhaar-digilocker-status/:loanId',
  PONAWALA_PATIENT_AADHAAR_VERIFIED: '/pw/patient-aadhaar-verified/:loanId',
  PONAWALA_MANDATE_SETUP: '/pw/mandate-setup/:loanId',
  PONAWALA_BANK_DETAILS_FOR_NACH: '/pw/bank-details-for-nach/:loanId',
  PONAWALA_BANK_VERIFIED: '/pw/bank-verified/:loanId',
  PONAWALA_MANDATE_AUTOPAY_SETUP: '/pw/mandate-autopay-setup/:loanId',
  PONAWALA_MANDATE_STATUS: '/pw/mandate-status/:loanId',
  PONAWALA_MANDATE_FAIL: '/pw/mandate-fail/:loanId',
  PONAWALA_MANDATE_DONE: '/pw/mandate-done/:loanId',
  PONAWALA_GENERATING_AGREEMENT: '/pw/generating-agreement/:loanId',
  PONAWALA_ESIGN_REDIRECT: '/pw/esign-redirect/:loanId',
  PONAWALA_FINAL: '/pw/final/:loanId',
  PONAWALA_STATUS_OFFER: '/pw/status-offer/:loanId',
  PONAWALA_BUREAU_APPROVED: '/pw/bureau-approved/:userId/:loanId',
  PONAWALA_LOAN_OFFERS: '/pw/loan-offers/:userId/:loanId',
  PONAWALA_DOCTOR_NOT_AVAILABLE: '/pw/doctor-not-available',
  PONAWALA_DIGI_BANK_STATEMENT: '/pw/digibankstatement/:userId',
  PONAWALA_AA_STATUS_CHECK: '/pw/aa-statuscheck/:loanId',
  PONAWALA_REJECTED: '/pw/rejected/:userId',
  PONAWALA_AGREEGATOR: '/pw/agreegator/:userId',
  PONAWALA_BANK_NOT_LIVE: '/pw/bank-not-registered/:loanId',



  FIBE_OTP_AUTHENTICATION: '/patient/fibeOtpAuthentication',
  FIBE_NUMBER_VERIFIED: '/patient/fibeNumberVerified',
  FIBE_WELCOME: '/patient/fibeWelcome',
  FIBE_CREDIT_DETAILS: '/patient/fibeCreditDetails',
  FIBE_PRESCRIPTION_UPLOAD: '/patient/fibePrescriptionUpload',
  FIBE_BASIC_DETAILS: '/patient/fibeBasicDetails',
  FIBE_EMPLOYMENT_DETAILS: '/patient/fibeEmploymentDetails',
  FIBE_GREAT_JOB: '/patient/fibeGreatJob',
  FIBE_CREATE_USER: '/patient/fibeCreateUser',
  FIBE_WAITING_FOR_APPROVAL: '/patient/fibeWaitingForApproval',
  FIBE_CHECKING_STATUS: '/patient/fibeCheckingStatus',
  FIBE_LOAN_APPROVED: '/patient/fibeLoanApproved',
  FIBE_BANK_STATEMENT_REQUIRED: '/patient/fibeBankStatementRequired',
  FIBE_LOAN_REJECTED: '/patient/fibeLoanRejected',
  FIBE_REDIRECTING: '/patient/fibeRedirecting',
  FIBE_USER_FALLBACK: '/patient/screen14/:userId',
  FIBE_CONGRATS_USER: '/patient/fibeCongratsUser',


  FETCHING_LOAN_LIMIT: '/patient/FetchingLoanLimit',
  APPROVED_LOAN_LIMIT_NEG: '/patient/ApprovedLoanLimitNeg',
  KYC_ALREADY_VERIFIED: '/patient/KycAlreadyVerified',
  KYC_VERIFICATION: '/patient/KycVerification',
  KYC_REDIRECTION: '/patient/KycRedirection',
  KYC_WEBVIEW: '/patient/KycWebview',
  KYC_VERIFYING: '/patient/KycVerifying',
  KYC_VERIFICATION_SUCCESSFUL: '/patient/KycVerificationSuccesful',

  INCOME_VERIFICATION: '/patient/IncomeVerification',
  FILE_UPLOAD: '/patient/FileUpload',
  STATEMENT_VERIFICATION_UNDER_PROCESS: '/patient/StatementVerificationUnderProcess',
  INCOME_VERIFICATION_STATUS: '/patient/IncomeVerificationStatus',
  STATEMENT_VERIFICATION_SUCCESSFUL: '/patient/StatementVerificationSuccesful',
  NEW_TENURE_CONFIRMATION: '/patient/NewTenureConfirmation',
  END_APPLICATION: '/patient/EndApplication',
  CONGRATS: '/patient/Congrats',

  BANK_DETAILS: '/patient/BankDetails',
  BANK_DETAILS_UNDER_PROCESS: '/patient/BankDetailsUnderProcess',
  BANK_VERIFYING: '/patient/BankVerifying',
  BANK_DETAILS_VERIFIED: '/patient/BankDetailsVerified',

  LOAN_AGREEMENT: '/patient/LoanAgreement',
  LOAN_REDIRECTION: '/patient/LoanRedirection',
  LOAN_WEBVIEW: '/patient/LoanWebview',
  VERIFYING_LOAN: '/patient/VerifyingLoan',
  LOAN_AGREEMENT_UNDER_PROCESS: '/patient/LoanAgreementUnderProcess',
  LOAN_VERIFICATION_SUCCESSFUL: '/patient/LoanVerificationSuccesful',

  EMANDATE: '/patient/Emandate',
  EMANDATE_REDIRECTION: '/patient/EmandateRedirection',
  EMANDATE_WEBVIEW: '/patient/EmandateWebview',
  VERIFYING_EMANDATE: '/patient/VerifyingEmandate',
  EMANDATE_UNDER_PROCESS: '/patient/EmandateUnderProcess',
  EMANDATE_VERIFICATION_SUCCESSFUL: '/patient/EmandateVerificationSuccesful',

  FIRST_PAYMENT_SCREEN: '/patient/FirstPaymentScreen',
  PG_REDIRECTION: '/patient/PGRedirection',
  PAYMENT_UNDER_PROCESS: '/patient/PaymentUnderProcess',
  PG_VERIFYING: '/patient/PGVerifying',
  PG_VERIFICATION_SUCCESSFUL: '/patient/PGVerificationSuccesful',
  LOAN_APP_UNDER_PROCESS: '/patient/LoanAppUnderProcess',
  LOAN_VERIFYING: '/patient/LoanVerifying',
  LOAN_APP_SUCCESSFUL: '/patient/LoanAppSuccessful',
  LOAN_APP_ON_HOLD: '/patient/LoanAppOnHold',

  USER_DASHBOARD: '/patient/UserDashboard',

  DOCTOR_HOMEPAGE: '/doctor',
  DOCTOR_VERIFY_OTP: '/doctor/verifyotp',
  DOCTOR_WELCOME: '/doctor/welcome',
  DOCTOR_PERSONAL_DETAILS: '/doctor/PersonalDetails',
  DOCTOR_PRACTICE_DETAILS: '/doctor/PracticeDetails',
  DOCTOR_ADDRESS_DETAILS: '/doctor/AddressDetails',
  DOCTOR_BANK_DETAILS: '/doctor/BankDetails',
  DOCTOR_UPLOAD_DOCUMENTS: '/doctor/UploadDocuments',
  DOCTOR_AGREEMENT: '/doctor/agreement',
  DOCTOR_THANK_YOU: '/doctor/ThankYou',
  SIGNZY_AGREEMENT: '/doctor/agreementsignzy',
  AGREEMENT_REFRESH: '/doctor/agreementstatus',
  AGREEMENT_TRY_AGAIN: '/doctor/retryagreement',
  UPLODED_DOC: '/doctor/uploaded',
  DOCTOR_DASHBOARD: '/doctor/dashboard/',
  ALL_TRANSACTIONS: '/doctor/dashboard/AllTransactions',
  ADD_PATIENT: '/doctor/dashboard/addPatient',
  UNDER_REVIEW: '/doctor/dashboard/UnderReview',
  LOGIN_FROM_URL: '/doctor/:doctorId',
  DOCTOR_AGREEMENT_DONE: '/doctor/agreementcompleted',
  QR_DATA: '/qrData/:doctorId',

  // ARTH_CREDIT_DETAILS: '/patient/ArthCreditDetails',
  ARTH_PRESCRIPTION_UPLOAD: '/patient/ArthPresciptionUpload',
  // ARTH_PERSONAL_DETAILS: '/patient/ArthPersonalDetails',
  // ARTH_ADDRESS_DETAILS: '/patient/ArthAddressDetails',
  ARTH_EMPLOYMENT_DETAILS: '/patient/ArthEmploymentDetails',
  // ARTH_CURRENT_EMI_EXPENSES: '/patient/ArthCurrentEMIExpenses',
  ARTHMATE_OFFERS: '/patient/ArthmateOffers',
  ARTH_INCOME_VERIFICATION: '/patient/ArthIncomeVerification',
  ARTH_BANK_SELECTION: '/patient/ArthBankSelection',
  ARTH_FILE_UPLOAD: '/patient/ArthFileUpload',
  ARTH_METHOD_SELECTION: '/patient/ArthMethodSelection',
  ARTH_CREDIT_AGREEMENT: '/patient/ArthCreditAgreement',
  ARTH_AGREEMENT_STATUS: '/patient/ArthAgreementStatus',
  ARTH_AUTO_REPAYMENT: '/patient/ArthAutoRepayment',
  ARTH_KYC: '/patient/ArthKyc',
  ARTH_AADHAAR_VERIFICATION: '/patient/ArthAadhaarVerification',
  ARTH_AADHAAR_PHOTO: '/patient/ArthAadhaarPhoto',
  ARTH_PAN_PHOTO: '/patient/ArthPANPhoto',
  ARTH_SELFIE: '/patient/ArthSelfie',
  ARTH_CONGRATULATIONS: '/patient/ArthCongratulations',
  ARTH_BANKDETAILS: '/patient/Arthbankdeails',
  ARTH_KYC_SUCCESS: '/patient/Arthdone',
  WAIT_ARTH: '/patient/wait',
  WAIT_LEGALITY: '/patient/legalitywait',
  APPROVAL_INCRED: '/patient/incredapproval',
  INCRED_DOWNLOAD: '/patient/increddownload',
  CONNECTING_WITH_LENDERS: '/patient/connecting',
  PLEASE_WAIT: '/patient/pleasewait',
  FINAL_SCREEN_ARTH: '/patient/final/*',
  WAIT_FOR_PROCESSING: '/patient/processing',
  INCRED_PREAPPROVED: '/patient/incredpreapproved',
  FLEX_WAIT_SCREEN: '/patient/flexwait',
  FLEX_APPROVAL_SCREEN: '/patient/flexApproval',
  FLEX_APPROVAL_WAIT: '/patient/refresh',
  REDIRECT_AUTO_MANDATE: '/patient/nachmandatewait/:userId',
  FLEX_USER_WAIT: '/patient/flexuserwait',
  DIGITAP_BANK_STATEMENT: '/patient/digibankstatement/:userId',
  DIGITAP_AGREEGATOR: '/patient/agreegator/:userId',
  PATIENT_TERMS: '/patient/termspatient',
  NOT_FOUND_SCREEN: '/patient/notfound',
  DIGITAP_REDIRECT_URL: '/patient/digitapredirection/*',
  DIGITAP_DATA_RECEIVED: '/patient/digireport/*',
  DIGITAP_REPORT_FAILURE: '/patient/reporfailure',
  DIGITAP_REPORT_FAILURE_NEW: '/patient/reporfailuretry',
  BANK_NAME_NOTMATCHED: '/patient/banknamenotmatched',
  BANK_API_NOT_WORKING: '/patient/bankserverdown',
  GREATER_LIMIT_BUREAU: '/patient/greterlimitbureau',
  FIRST_LIMIT_FALSE: '/patient/lesslimit/:userId',
  SECOND_LIMIT_FALSE: '/patient/changelimit/:userId',
  DEMO: '/demo',
  PAY_SCREEN: '/patient/offerspayu/:loanId',
  PAY_SCREEN_REFRESH: '/patient/payurefresh/:paymentId',
  PAY_STATUS: '/patient/payustatus',
  RAZORPAY_OFFERS: '/patient/razorpayoffer/:userId',
  RAZORPAY_MANDATE: '/patient/razorpaymandate/:loanId',
  RAZORPAY_SCREEN_REFRESH: '/patient/razorpayrefresh/:loanId',
  RAZORPAY_SCREEN_STATUS: '/patient/razorpaystatus',

  MONEY_VIEW_BANKSTATEMENT: '/patient/mvbankstatement',
  MVREFRESH: '/patient/mvrefresh/:loanId',
  MV_CONGRATULATIONS: '/patient/mvcongratulations',
  MVREFRESH_FINAL: '/patient/mvfinalrefresh/:loanId',
  MVREFRESH_TRY_AGAIN: '/patient/mvtryagain',
  BANK_LIST: '/patient/banklist',
  FINZY_AADHAR_WAIT: '/patient/aadharwait',
  FINZY_AADHAR_VERIFICATION: '/patient/aadharVerification',
  FINZY_APPROVAL: '/patient/approvalfinzy',
  FINZY_AGREEMENT: '/patient/fmandate',
  FINZY_WAIT: '/patient/fwait',
  FINZY_ESIGN_TRY_AGAIN: '/patient/ftryagain',
  FINZY_NACH_MANDATE: '/patient/fach/:loanId',
  FINZY_APPROVE_LESS_AMOUNT: '/patient/approvefinzy',
  STATUS_WAIT_FINZY: '/patient/fstatuswait',
  FINZY_TRY_AGAIN: '/patient/retryfinzymandate',
  WAIT_DOC_UPLOAD: '/patient/waitdocument',
  ADDITIONAL_INFO: '/patient/addinfo',
  JUSTPAY_REDIRECT: '/patient/justpayredirect',
  AADHAR_OTP: '/patient/aadharotp',
  MUTUAL_FUND_1: '/patient/loanonmutualfunds1',
  MUTUAL_FUND_OTP: '/patient/OTPsubmitforloanonmutualfunds1',
  CRIF_COMPONENT: '/patient/crif',
  JUSTPAY_STATUS: '/patient/juspaystatuschecker/:loanId',
  JUSTPAY_FAILED: '/patient/justpayretry/:loanId',
  JUSTPAY_NO_OFFERS: '/patient/juspaynooffers',
  JUST_PAY_EXISTING: '/patient/justpayexisting',
  FETCHING_CARDS: '/patient/fetching',
  BANK_NOT_LIVE: '/patient/banknotregitered',
  MANDATE_NULL: '/patient/madatenotfound',
  MANDATE_FAILED: '/patient/mandatefail/*',
  AUTO_MANDATE_CHECK: '/patient/autopaystatus/*',
  UPDATED_AUTO_MANDATE_CHECK: '/patient/updatedautopaystatus/*',
  DIGIO_KYC_SUCCESS: '/patient/kycrefresh/:loanId/*',

// or showing EMI plans for cashfree - use this URL - 
// patient//patient/cardlessapproved-cashfree/{{loanId}}

// Design is similar to /patient/cardlessapproved-juspay
  FINDOC_BANK_DETAILS: '/patient/findocbankdetails',
  FINDOC_KYC_INTRO: '/patient/FindocKYCintro/:userId',
  FINDOC_FINDOC_SELFIE: '/patient/FindocSelfiecapture',
  FINDOC_CURRENT_ADDRESS: '/patient/currentaddressverification',
  FINDOC_FINDOC_AGREEMENT: '/patient/findocagreement',
  FINDOC_AADHAR_VERIFY: '/patient/verifyAadhaar',
  FINDOC_PROFESSTIONA_DETAILS: '/patient/professional/:userId',
  FINDOC_BUREAU_APPROVED: '/patient/bureauapproved/:userId',
  FINDOC_PEROSONAL_DETAILS: '/patient/fdpersonalDetails/:userId',
  FINDOC_ADDRESS_DETAILS: '/patient/postapprovalAddressdetails/*',
  FINDOC_AADHAR_VERIFIED: '/patient/aadhaarverified/*',
  FINDOC_CONCENT: '/patient/fdbureauconsent',
  FINDOC_CREDIT_LOADING: '/patient/creditassessmentbureau/:loanId',
    FINDOC_CREDIT_LOADING_MULTIPLE: '/patient/creditassessmentbureaumultiple/:loanId',

  FACE_VERIFICATION: '/patient/faceverification/:userId',
  FACE_VERIFIED: '/patient/faceverified/*',
  FINTREE_LOAN_BOOKING: '/patient/fintreeloanbooking/*',
  FINTREE_INITIATE_ESIGN: '/patient/fintreeinitiateesign/*',
  FINTREE_STATUS: '/patient/fintreestatus/*',
  AGREEMENT_SIGNING: '/patient/agreementesigning/*',
  AGRREMENT_REFRESH: '/patient/agreementstatuschecker/*',
  AGREEMENT_SIGNED: '/patient/agreementsigned/:loanId',
  EMI_AUTO_PAY_INTRO: '/patient/emiautopayintro/:loanId',
  BANK_DETAILS_FOR_NACH: '/patient/bankdetailsforNACH/*',
  EMI_AUTO_PAY_SETUP: '/patient/emiautopaysetup/*',
  UPDATED_MANDATE: '/patient/updatedmandate/*',
  BANK_VERIFIED_FINDOC: '/patient/bankverified/*',
  MANDATE_VERIFIED_FINDOC: '/patient/mandatedone/*',
  MANUAL_INTER_VENTION: '/patient/manualintervention/:userId',
  BS_APPROVED_EMI: '/patient/BSapprovedEMI/:loanId',
  AGREEMENT_REDIRECTION: '/patient/redirectionforagreement',
  LMAF_ELIGIBLE: '/patient/lamfEligible',
  LMAF_NOT_ELIGIBLE: '/patient/lamfIneligible',
  TRY_AGAIN_DIGITAP: '/patient/failed',
  CARDLESS_EMI: '/patient/cardlessapproved-juspay/:userId',
  CARDLESS_FAILED: '/patient/cardlessfailed',
  CARDLESS_STATUS: '/patient/cardlessstatuschecker/*',
  KYC_AADHAAR_VERIFICATION: '/patient/KycAadhaarVerification',
  AGG_FAIL: '/patient/agreementfailure/*',
  EMI_DESIGN: '/emiplandesign',
  OTP_VERIFY_FAILED: '/patient/verificationfailed/*',
  ENTER_OTP_NEW: '/patient/aadharenterotp',
  DIGILOCKER_KYC_INTRO: '/patient/digilockerintro/:loanId',
  AADHAR_NUMBER_INPUT: '/patient/aadhaarnumberinput/:userId',
  DIGILOCKER_STATUS: 'patient/aadhaarstatusdigilocker/:loanId',
  OKYC_DOWN: '/patient/okycdown/*',
  LOAN_OFFERS:'/patient/loanoffers/:loanId/:userId',
DIGIO_KYC: '/patient/digiokyc/:loanId',
DIGIO_REQUESTED: '/patient/kycfailed/:loanId',
INSUFFICIENT_DATE_RANGE: '/patient/insufficientdaterange/:userId',

  ////fibev2

  V2FibeLoanApproved: '/patient/fibev2approved/:loanId',
  V2_FIBE_EMI_SELECTION: '/patient/fibeV2EMIplanselection/:loanId',
  V2_LESSER_LIMIT: '/patient/fibelesserlimitapproved/:loanId',
  V2_BANK_STATMENT_REQUIRED: '/patient/fibeV2BankStatementRequired/:loanId',
  FIBE_STATUS_CHECKER: '/patient/fibebsstatuschecker/:loanId',
  FIBE_V2_REDIRECT: '/patient/fibenavigation/:loanId',
  CLICK_WRAP_SIGNING: '/patient/signing/:loanId',
  INDEPENDENT_FIBE_PUSH:'/patient/junction/*',


  ///ecomm///
  ECOMMERCE: '/ecommerce',
  ECOMMERCE_DEPARYMENT: '/ecommerce/departmentdoctor',
  ECOMMERCE_INDIVIDUAL_DOCTOR: '/ecommerce/individual',
  ECOMMERCE_BOOKING_DOCTOR: '/ecommerce/booking',
  ECOMMERCE_PAYMENT: '/ecommerce/payment/:userId',
  ECOMMERCE_RAZORPAY: '/ecommerce/razorpay/*',
  FetchingOffer: '/ecommerce/fetchingoffer',



////CASHFREE///
CASHFREE_OFFERS:'/patient/cardlessapproved-cashfree/:loanId',

//LAZYPAY///
LAZYPAY_OFFERS:'/patient/lazypay-approved/:loanId',
LAZYPAY_STATUS_CHECKER:'/patient/lazypaystatuschecker/:loanId',
FAILED_LAZYPAY:'/patient/failedlazypay/:loanId',







  ///SCOUTS///
  SCOUTS_MAIN: '/scouts',
  SCOUTS_LOGIN: '/scouts/login',
  SCOUTS_OTP: '/scouts/verifyotp',
  SCOUTS_ALREADYEXIST: '/scouts/alreadyexist',
  SCOUTES_WELCOME: '/scouts/welcome',
  SCOUTES_PERSONAL: '/scouts/personal',
  SCOUTES_PRACTICE: '/scouts/practice',
  SCOUTES_ADDRESS: '/scouts/address',
  SCOUTES_BANK: '/scouts/bank',
  SCOUTES_DOC: '/scouts/document',
  SCOUTES_ONBOARD_LEADS: '/scouts/onboardleads',
  SCOUTES_LOANS: '/scouts/allloans',
  SCOUTES_LIVE_CLINIC: '/scouts/liveclinic',
  SCOUTES_CLINIC_LEADS: '/scouts/clinicleads',
  ///JOFIN

  JOFIN_VERIFYING: '/pl/approval-auto-login/:userId',
  JOFIN_APPROVED: '/pl/joapproved/:userId',
  JOFIN_EMI_CONFIRMED: '/pl/joemiconfirmed/:userId',
  JOFIN_AADHAR_VERIFICATION: '/pl/joaadharverification/:userId',
  JOFIN_DIGILOCKER_KYC_INTRO: '/pl/digilockerintro/:userId',
  JOFIN_DASHBOARD: '/pl/jofindashboard/:userId',
  JOFIN_AGREEMENT_SIGNING: '/pl/agreementesigning/:userId',
  JOFIN_AGREEMENT_SIGNED: '/pl/agreementsigned/:loanId',
  JOFIN_EMI_AUTO_PAY_INTRO: '/pl/emiautopayintro/:loanId',

  JOFIN_FINDOC_CURRENT_ADDRESS: '/pl/currentaddressverification',
  JOFIN_FINDOC_AADHAR_VERIFIED: '/pl/aadhaarverified',
  JOFIN_FACE_VERIFICATION: '/pl/faceverification/:userId',
  JOFIN_FACE_VERIFIED: '/pl/faceverified/:userId',
  JOFIN_AGRREMENT_REFRESH: '/pl/agreementstatuschecker/userId',
  JOFIN_BANK_DETAILS_FOR_NACH: '/pl/bankdetailsforNACH/:loanId',
  JOFIN_EMI_AUTO_PAY_SETUP: '/pl/emiautopaysetup/:loanId',
  JOFIN_BANK_VERIFIED_FINDOC: '/pl/bankverified/:loanId',
  JOFIN_MANDATE_VERIFIED_FINDOC: '/pl/mandatedone/:userId',
  JOFIN_AGREEMENT_REDIRECTION: '/pl/redirectionforagreement',
  JOFIN_AGG_FAIL: '/pl/agreementfailure/:userId',
  JOFIN_MANDATE_FAILED: '/pl/autopaystatus',
  JOFIN_AUTO_MANDATE_CHECK: '/pl/autopaystatus/*',
  JOFIN_FINAL_SCREEN_ARTH: '/pl/final/:userId',
  JOFIN_DIGILOCKER_STATUS: '/pl/aadhaarstatusdigilocker/:loanId',
  JOFIN_OTP_VERIFY_FAILED: '/pl/verificationfailed/:userId',
  JOFIN_CLICK_WRAP_SIGNING: '/pl/signing/:loanId',
  JOFIN_VIEW_PEROSONAL:'/pl/viewpersonal/:userId',
    JOFIN_VIEW_ADDRESS:'/pl/viewaddress/:userId',
    PL_JOURNEY:'/pl/journey/:userId',
      JOFIN_BANK_NOT_LIVE: '/pl/banknotregitered/:userId',
  JOFIN_MANDATE_NULL: '/pl/madatenotfound',
  JOFIN_MANDATE_FAILED: '/pl/mandatefail/*',


  ////newwebsite////
HOME_PAGE_NEW:'/',
CAREENA_AI:'/product/careena-ai',
OCULON:'/product/oculon',
INSTANT_CARE_CHECKOUT:'/product/instant-care-checkout',
PAY_IN_PARTS:'/product/payinparts',
RECONCILE:'/product/reconcile',
HOPEGUARD:'/product/hopeguard',
CAREPAY_DEMO:'/requestdemo',
FOR_PATIENTS:'/solution/for-patients',
FOR_LENDERS:'/solution/for-lendersnbfcs-insurers',
FOR_CLINICS:'/solution/for-clinics-daycare-hospitals',
WHY_CAREPAY:'/whycarepay',
ABOUT_CAREPAY:'/aboutus',
PRICING:'/pricing',
CONTACT_US:'/contactus',
OUR_TEAM:'/ourteam',
TERMS_CONDITIONS:'/terms-and-conditions',
PRIVACY_POLICY_NEW:'/privacy-policy',
SECURITY:'/security',
COMPLIANCE:'/compliance',
LENDING_PARTNERS_NEW:'/lending-partners',
PUBLIC_NOTICE:'/public-notice',


//////medical/////
USER_LOGIN:'/user/login',
CONTINUE_TO_APPLICATION:'/user/continueapplication/:userId',
USER_DASHBOARD_DETAILS:'/user/userdashboard/:userId',
LOAN_DETAILS_MEDICAL:'/user/loandetails/:userId',
SELECT_CLINIC:'/user/selectclinic/:userId',

///ZYPE////
ZYPE_BUREAU_APPROVED: '/patient/zypebureauapproved/:userId',
ZYPE_STATUS_CHECKER: '/patient/zypebsstatuschecker/:loanId',
ZYPE_PARTIAL_APPROVED: '/patient/zype-partial-approved/:loanId',
ZYPE_CONTINUE: '/patient/zype-continue/:loanId',
ZYPE_REJECTED: '/patient/zype-rejected/:loanId/:userId',























};

export default routes;















// const routes = {
//     WEB_HOMEPAGE: '/',
//     ABOUT: '/about',
//     PRIVACY_POLICY: '/PrivacyPolicy',
//     TERMS_AND_CONDITIONS: '/TermsAndConditions',
//     REFUND_AND_CANCELLATION: '/RefundandCancellation',
//     ICICI_TERMS_AND_CONDITIONS: '/ICICITermsAndConditions',

//     DOC_HOMEPAGE: '/doctor',
//     DOC_VERIFY_OTP: '/doctor/verifyotp',
//     DOCTOR_WELCOME: '/doctor/welcome',
//     DOCTOR_PERSONAL_DETAILS: '/doctor/PersonalDetails',
//     DOCTOR_PRACTICE_DETAILS: '/doctor/PracticeDetails',
//     DOCTOR_ADDRESS_DETAILS: '/doctor/AddressDetails',
//     DOCTOR_BANK_DETAILS: '/doctor/BankDetails',
//     DOCTOR_UPLOAD_DOCUMENTS: '/doctor/UploadDocuments',
//     DOCTOR_THANK_YOU: '/doctor/ThankYou',
//     DOCTOR_DASHBOARD: '/doctor/dashboard/',
//     DOCTOR_ALL_TRANSACTIONS: '/doctor/dashboard/AllTransactions',
//     DOCTOR_ADD_PATIENT: '/doctor/dashboard/addPatient',
//     DOCTOR_UNDER_REVIEW: '/doctor/dashboard/UnderReview',
//     DOCTOR_LOGIN_FROM_URL: '/doctor/:doctorId',
//     QR_DATA: '/qrData/:doctorId',

//     HOMEPAGE: '/patient',
//     DOCTOR_NOT_AVAILABLE : '/patient/DoctorNotAvailable',
//     MOBILE_NUMBER_VERIFICATION: '/patient/MobileNumberVerification',
//     ENTER_OTP: '/patient/EnterOTP',
//     PHONE_NUMBER_VERIFIED: '/patient/PhoneNumberVerified',
//     CREDIT_DETAILS: '/patient/CreditDetails',
//     PRESCRIPTION_UPLOAD: '/patient/PrescriptionUpload',
//     PERSONAL_DETAILS: '/patient/PersonalDetails',
//     NOT_SERVICEABLE: '/patient/NotServiceable',
//     ADDRESS_DETAILS: '/patient/AddressDetails',
//     ADDRESS_NOT_SERVICEABLE: '/patient/AddressNotServiceable',
//     EMPLOYMENT_DETAILS: '/patient/EmploymentDetails',
//     FETCHING_LOAN_LIMIT: '/patient/FetchingLoanLimit',
//     APPROVED_LOAN_LIMIT_NEG: '/patient/ApprovedLoanLimitNeg',
//     LOAN_DETAILS: '/patient/LoanDetails',
//     KYC_ALREADY_VERIFIED: '/patient/KycAlreadyVerified',
//     KYC_VERIFICATION: '/patient/KycVerification',
//     KYC_REDIRECTION: '/patient/KycRedirection',
//     KYC_WEBVIEW: '/patient/KycWebview',
//     KYC_VERIFYING: '/patient/KycVerifying',
//     KYC_VERIFICATION_SUCCESSFUL: '/patient/KycVerificationSuccesful',
//     INCOME_VERIFICATION: '/patient/IncomeVerification',
//     FILE_UPLOAD: '/patient/FileUpload',
//     STATEMENT_VERIFICATION_UNDER_PROCESS: '/patient/StatementVerificationUnderProcess',
//     INCOME_VERIFICATION_STATUS: '/patient/IncomeVerificationStatus',
//     STATEMENT_VERIFICATION_SUCCESSFUL: '/patient/StatementVerificationSuccesful',
//     NEW_TENURE_CONFIRMATION: '/patient/NewTenureConfirmation',
//     END_APPLICATION: '/patient/EndApplication',
//     CONGRATS: '/patient/Congrats',
//     BANK_DETAILS: '/patient/BankDetails',
//     BANK_DETAILS_UNDER_PROCESS: '/patient/BankDetailsUnderProcess',
//     BANK_VERIFYING: '/patient/BankVerifying',
//     BANK_DETAILS_VERIFIED: '/patient/BankDetailsVerified',
//     LOAN_AGREEMENT: '/patient/LoanAgreement',
//     LOAN_REDIRECTION: '/patient/LoanRedirection',
//     LOAN_WEBVIEW: '/patient/LoanWebview',
//     VERIFYING_LOAN: '/patient/VerifyingLoan',
//     LOAN_AGREEMENT_UNDER_PROCESS: '/patient/LoanAgreementUnderProcess',
//     LOAN_VERIFICATION_SUCCESSFUL: '/patient/LoanVerificationSuccesful',
//     E_MANDATE: '/patient/Emandate',
//     E_MANDATE_REDIRECTION: '/patient/EmandateRedirection',
//     E_MANDATE_WEBVIEW: '/patient/EmandateWebview',
//     VERIFYING_E_MANDATE: '/patient/VerifyingEmandate',
//     E_MANDATE_UNDER_PROCESS: '/patient/EmandateUnderProcess',
//     E_MANDATE_VERIFICATION_SUCCESSFUL: '/patient/EmandateVerificationSuccesful',
//     FIRST_PAYMENT_SCREEN: '/patient/FirstPaymentScreen',
//     PG_REDIRECTION: '/patient/PGRedirection',
//     PAYMENT_UNDER_PROCESS: '/patient/PaymentUnderProcess',
//     PG_VERIFYING: '/patient/PGVerifying',
//     PG_VERIFICATION_SUCCESSFUL: '/patient/PGVerificationSuccesful',
//     LOAN_APP_UNDER_PROCESS: '/patient/LoanAppUnderProcess',
//     LOAN_VERIFYING: '/patient/LoanVerifying',
//     LOAN_APP_SUCCESSFUL: '/patient/LoanAppSuccessful',
//     LOAN_APP_ON_HOLD: '/patient/LoanAppOnHold',
//     USER_DASHBOARD: '/patient/UserDashboard',

//     ARTH_CREDIT_DETAILS: '/patient/ArthCreditDetails',
//     ARTH_PRESCRIPTION_UPLOAD: '/patient/ArthPrescriptionUpload',
//     ARTH_PERSONAL_DETAILS: '/patient/ArthPersonalDetails',
//     ARTH_ADDRESS_DETAILS: '/patient/ArthAddressDetails',
//     ARTH_EMPLOYMENT_DETAILS: '/patient/ArthEmploymentDetails',
//     ARTH_CURRENT_EMI_EXPENSES: '/patient/ArthCurrentEMIExpenses',
//     ARTHMATE_OFFERS: '/patient/ArthmateOffers',
//     ARTH_INCOME_VERIFICATION: '/patient/ArthIncomeVerification',
//     ARTH_BANK_SELECTION: '/patient/ArthBankSelection',
//     ARTH_FILE_UPLOAD: '/patient/ArthFileUpload',
//     ARTH_METHOD_SELECTION: '/patient/ArthMethodSelection',
//     ARTH_CREDIT_AGREEMENT: '/patient/ArthCreditAgreement',
//     ARTH_AGREEMENT_STATUS: '/patient/ArthAgreementStatus',
//     ARTH_AUTO_REPAYMENT: '/patient/ArthAutoRepayment',
//     ARTH_KYC: '/patient/ArthKyc',
//     ARTH_AADHAAR_VERIFICATION: '/patient/ArthAadhaarVerification',
//     ARTH_PAN_PHOTO: '/patient/ArthPANPhoto',
// };

// export default routes;






// const routes = {
//     WEB_HOMEPAGE: '/',
//     ABOUT: '/about',
//     PRIVACY_POLICY : '/PrivacyPolicy',
//     TERMS_AND_CONDITIONS : '/TermsAndConditions',
//     REFUND_AND_CANCELLATION : '/RefundandCancellation',
//     ICICI_TERMS_AND_CONDITIONS : '/ICICITermsAndConditions',
//     DOC_HOMEPAGE : '/doctor',
//     DOC_VERIFY_OTP : '/doctor/verifyotp',
//     HOMEPAGE : '/patient',
//     MOBILE_NUMBER_VERIFICATION : '/patient/MobileNumberVerification',

// }
// export default routes;

  // // DIGITAP_BANK_STATEMENT: '/patient/digibankstatement/:userId',
  // // BS_APPROVED_EMI: '/patient/BSapprovedEMI/:loanId',
  // // FINDOC_BUREAU_APPROVED: '/patient/bureauapproved/*',

  // // DIGILOCKER_KYC_INTRO: '/patient/digilockerintro/*',
  // AGREEMENT_SIGNING: '/patient/agreementesigning/*',
  // BANK_DETAILS_FOR_NACH: '/patient/bankdetailsforNACH/*',


